<div class="loading-indicator">
    <mat-progress-spinner mode="indeterminate" *ngIf="meetingDataSource.loading$ | async" bdColor="rgba(51,51,51,0.8)"
        diameter='25' strokeWidth='3'></mat-progress-spinner>
</div>
<div class="loading-indicator">
    <mat-progress-spinner mode="indeterminate" *ngIf="isLoading" bdColor="rgba(51,51,51,0.8)" diameter='25'
        strokeWidth='3'></mat-progress-spinner>
</div>
<section class="d-flex justify-content-end mar-r-10px">
    <!-- <div class="example-button-row d-flex justify-content-end mar-r-10px"> -->
    <button joyrideStep="searchNineStep" text="{{searchTourValues.searchNineStep}}" mat-raised-button color="primary"
        (click)="resetData()" container="body" tooltip="Clear All">CLEAR ALL</button>
    <!-- </div> -->
</section>
<div class="table_mat_search">
    <div class="grid-container">
        <table mat-table [dataSource]="meetingDataSource" matSort [ngStyle]="{'width':'100%'}"
            (matSortChange)="sortData($event)">

            <!-- Date Column -->
            <ng-container matColumnDef="meetingDate">
                <th mat-header-cell *matHeaderCellDef>
                    <div>
                        <div mat-sort-header class="task_header">
                            Date
                        </div>
                        <!--<mat-form-field class="filter_div" *ngIf="isFilterApplied" floatLabel="never" [ngStyle]="{'width':'100px'}">
                          <input matInput [formControl]="dateFilter" placeholder="Meeting Date">
                      </mat-form-field>-->
                        <mat-form-field joyrideStep="searchFirstStep" text="{{searchTourValues.searchFirstStep}}"
                            class="filter_div" *ngIf="isFilterApplied" floatLabel="always" [ngStyle]="{'width':'130px'}">
                            <input matInput [formControl]="dateFilter" [(ngModel)]="searchValue.meetingDate"
                                [matDatepicker]="picker" (focus)="picker.open()" (dateInput)="applyfilter(searchValue)"
                                [readonly]="true">
                            <mat-datepicker #picker></mat-datepicker>
                            <button mat-button matSuffix mat-icon-button aria-label="Clear" class="close-icon-bttn"
                                (click)="clearSearchField(displayedColumns[0],searchValue)"
                                *ngIf="searchValue.meetingDate">
                                <mat-icon [ngStyle]="{'font-size':'large', 'cursor':'pointer', 'vertical-align':'initial'}">
                                    close
                                </mat-icon>
                            </button>
                        </mat-form-field>
                    </div>
                </th>
                <td class="removeBorder" mat-cell *matCellDef="let element"> {{element.meetingDateStr}} </td>
            </ng-container>

            <!-- Title Column -->
            <ng-container matColumnDef="meetingTitle">
                <th mat-header-cell *matHeaderCellDef>
                    <div>
                        <div mat-sort-header class="task_header">
                            Meeting Title
                        </div>
                        <mat-form-field joyrideStep="searchSecondStep" text="{{searchTourValues.searchSecondStep}}"
                            class="filter_div" *ngIf="isFilterApplied" floatLabel="always" [ngStyle]="{'width':'290px'}">
                            <input matInput [formControl]="titleFilter" [(ngModel)]="searchValue.meetingTitle"
                                (keyup)="filterValue(searchValue,$event)">
                            <button mat-button matSuffix mat-icon-button aria-label="Clear" class="close-icon-bttn"
                                (click)="clearSearchField(displayedColumns[1],searchValue)"
                                *ngIf="searchValue.meetingTitle">
                                <mat-icon [ngStyle]="{'font-size':'large', 'cursor':'pointer', 'vertical-align':'initial'}">
                                    close
                                </mat-icon>
                            </button>
                        </mat-form-field>
                    </div>
                </th>
                <td class="removeBorder" mat-cell *matCellDef="let element" >
                    <!-- <button joyrideStep="searchElevenStep" text="{{searchTourValues.searchElevenStep}}" mat-icon-button
                        placement="left" tooltip="Information" triggers="hover">
                        <!-- <mat-icon class="info-mat-icon" (click)="loadMeetingInfo(meeting.meetingId)">info</mat-icon> -->
                    <!-- <mat-icon class="info-mat-icon" (click)="loadMeetingInfo(element)">info</mat-icon> -->
                    <!-- </button> -->
                    <div class="d-flex justify-content-between align-items-center" [ngStyle]="{'width':'355px'}">
                        <div tooltip = "{{element.meetingTitle}}" triggers = "hover" placement = "end" class="col-md-9" [ngStyle]="{'overflow':'hidden', 'white-space':'nowrap', 'text-overflow':'ellipsis'}">
                            <a id="MEETING" class="f-weight a-size pointer margin-0" joyrideStep="searchTwelveStep" text="{{searchTourValues.searchTwelveStep}}"
                                [routerLink]="[]" (click)="redirectToMeeting(element,searchValue)">
                                {{element.meetingTitle}} </a>
                        </div>
                        <div class="d-flex col-md-3">
                            <button joyrideStep="searchElevenStep" text="{{searchTourValues.searchElevenStep}}"
                                mat-icon-button placement="left" tooltip="Information" triggers="hover">
                                <!-- <mat-icon class="info-mat-icon" (click)="loadMeetingInfo(meeting.meetingId)">info</mat-icon> -->
                                <mat-icon class="info-mat-icon" (click)="loadMeetingInfo(element)">info</mat-icon>
                            </button>
                            <button mat-icon-button [matMenuTriggerFor]="menus">
                                <mat-icon class="vert-mat-icon" tooltip="More" triggers="hover">more_vert</mat-icon>
                            </button>
                            <mat-menu #menus="matMenu">
                                <button (click)="copyMeeting(element)"
                                    class="body-font-size d-flex align-items-center menu-btn-alignment allowAfterApprove">
                                    <mat-icon class="mat-icon-menu">file_copy</mat-icon>
                                    <h3 class="mat-menu-content-alignment text-capitalize margin-0">Copy Meeting / Follow-Up Meeting</h3>
                                </button>
                                <button (click)="cancelMeetingPopup(element)" *ngIf = "element.meetingStatusDesc == 'Scheduled' || element.meetingStatusDesc == 'Yet to Schedule'"  class="body-font-size d-flex align-items-center menu-btn-alignment allowAfterApprove">
                                    <mat-icon class="mat-icon-menu"> cancel_presentation</mat-icon>
                                    <h3 class="mat-menu-content-alignment text-capitalize margin-0">Cancel Meeting</h3>
                                </button>
                            </mat-menu>
                        </div>
                    </div>
                    <!-- <button mat-icon-button [matMenuTriggerFor]="menus">
                        <mat-icon class="vert-mat-icon" tooltip="More" triggers="hover">more_vert</mat-icon>
                    </button> -->
                    
                </td>
            </ng-container>

            <!-- Agenda Column -->
            <ng-container matColumnDef="agendaTopic">
                <th mat-header-cell *matHeaderCellDef>
                    <div>
                        <div mat-sort-header class="task_header">
                            Agenda
                        </div>
                        <mat-form-field joyrideStep="searchThirdStep" text="{{searchTourValues.searchThirdStep}}"
                            class="filter_div" *ngIf="isFilterApplied" floatLabel="always" [ngStyle]="{'width':'280px'}">
                            <input matInput [formControl]="agendaFilter" [(ngModel)]="searchValue.agendaTopic"
                                (keyup)="filterValue(searchValue,$event)">
                            <button mat-button matSuffix mat-icon-button aria-label="Clear" class="close-icon-bttn"
                                (click)="clearSearchField(displayedColumns[2],searchValue)"
                                *ngIf="searchValue.agendaTopic">
                                <mat-icon [ngStyle]="{'font-size':'large', 'cursor':'pointer', 'vertical-align':'initial'}">
                                    close
                                </mat-icon>
                            </button>
                        </mat-form-field>
                    </div>
                </th>
                <td class="removeBorder" *matCellDef="let element"> {{element.agendaNames}}{{element.agendaTopic}} </td>
            </ng-container>

            <!-- Facilitator Column -->
            <ng-container matColumnDef="facilitator">
                <th mat-header-cell *matHeaderCellDef>
                    <div>
                        <div mat-sort-header class="task_header">
                            Facilitator
                        </div>
                        <mat-form-field class="filter_div" *ngIf="isFilterApplied" joyrideStep="searchFourthStep"
                            text="{{searchTourValues.searchFourthStep}}" floatLabel="always" [ngStyle]="{'width':'140px'}">
                            <input matInput [formControl]="facilitatorFilter" [(ngModel)]="searchValue.facilitator"
                                (keyup)="filterValue(searchValue,$event)">
                            <button mat-button matSuffix mat-icon-button aria-label="Clear" class="close-icon-bttn"
                                (click)="clearSearchField(displayedColumns[3],searchValue)"
                                *ngIf="searchValue.facilitator">
                                <mat-icon [ngStyle]="{'font-size':'large', 'cursor':'pointer', 'vertical-align':'initial'}">
                                    close
                                </mat-icon>
                            </button>
                        </mat-form-field>
                    </div>
                </th>
                <td class="removeBorder" mat-cell *matCellDef="let element"> {{element.facilitator}} </td>
            </ng-container>

            <!-- Participants Column -->
            <ng-container matColumnDef="participants">
                <th mat-header-cell *matHeaderCellDef>
                    <div>
                        <div mat-sort-header class="task_header">
                            Participants
                        </div>
                        <mat-form-field class="filter_div" *ngIf="isFilterApplied" joyrideStep="searchFiveStep"
                            text="{{searchTourValues.searchFiveStep}}" floatLabel="always" [ngStyle]="{'width':'280px'}">
                            <input matInput [formControl]="participantsFilter" [(ngModel)]="searchValue.participants"
                                (keyup)="filterValue(searchValue,$event)">
                            <button mat-button matSuffix mat-icon-button aria-label="Clear" class="close-icon-bttn"
                                (click)="clearSearchField(displayedColumns[4],searchValue)"
                                *ngIf="searchValue.participants">
                                <mat-icon [ngStyle]="{'font-size':'large', 'cursor':'pointer', 'vertical-align':'initial'}">
                                    close
                                </mat-icon>
                            </button>
                        </mat-form-field>
                    </div>
                </th>
                <td class="removeBorder" mat-cell *matCellDef="let element">
                    {{element.attendeeNames!=null?element.attendeeNames:element.ateendeeNames}} </td>
            </ng-container>

            <!-- Type Column -->
            <ng-container matColumnDef="meetType">
                <th mat-header-cell *matHeaderCellDef>
                    <div>
                        <div mat-sort-header class="task_header">
                            Type
                        </div>
                        <mat-form-field joyrideStep="searchSixStep" text="{{searchTourValues.searchSixStep}}"
                            class="filter_div" *ngIf="isFilterApplied" floatLabel="always" [ngStyle]="{'width':'120px'}">
                            <input matInput [formControl]="typeFilter" [(ngModel)]="searchValue.meetType"
                                (keyup)="filterValue(searchValue,$event)">
                            <button mat-button matSuffix mat-icon-button aria-label="Clear" class="close-icon-bttn"
                                (click)="clearSearchField(displayedColumns[5],searchValue)"
                                *ngIf="searchValue.meetType">
                                <mat-icon [ngStyle]="{'font-size':'large', 'cursor':'pointer', 'vertical-align':'initial'}">
                                    close
                                </mat-icon>
                            </button>
                        </mat-form-field>
                    </div>
                </th>
                <td class="removeBorder" mat-cell *matCellDef="let element"> {{element.meetingTypeDesc}}{{element.meetType}} </td>
            </ng-container>

            <!-- Status Column -->
            <ng-container matColumnDef="meetStatus">
                <th mat-header-cell *matHeaderCellDef>
                    <div>
                        <div mat-sort-header class="task_header">
                            Status
                        </div>
                        <mat-form-field joyrideStep="searchSevenStep" text="{{searchTourValues.searchSevenStep}}"
                            class="filter_div" *ngIf="isFilterApplied" floatLabel="always" [ngStyle]="{'width':'140px'}">
                            <input matInput [formControl]="statusFilter" [(ngModel)]="searchValue.meetStatus"
                                (keyup)="filterValue(searchValue,$event)">
                            <button mat-button matSuffix mat-icon-button aria-label="Clear" class="close-icon-bttn"
                                (click)="clearSearchField(displayedColumns[6],searchValue)"
                                *ngIf="searchValue.meetStatus">
                                <mat-icon [ngStyle]="{'font-size':'large', 'cursor':'pointer', 'vertical-align':'initial'}">
                                    close
                                </mat-icon>
                            </button>
                        </mat-form-field>
                    </div>
                </th>
                <!-- <td mat-cell *matCellDef="let element">{{element.meetingStatusDesc=='A'?'Approved':element.meetingStatusDesc}} </td> -->
                <td class="removeBorder" mat-cell *matCellDef="let element">{{element.meetingStatusDesc}} <mat-icon
                        *ngIf="element.isMomApproved!=null && element.isMomApproved=='Y'" class="pdf_icon" tooltip="pdf"
                        (click)="openPreviewMinutes(element)">picture_as_pdf</mat-icon>
                </td>
            </ng-container>

            <!-- Confidential Column -->
            <ng-container matColumnDef="isConfidential">
                <th mat-header-cell *matHeaderCellDef>
                    <div>
                        <div mat-sort-header class="task_header">
                            Confidential
                        </div>
                        <mat-form-field joyrideStep="searchEightStep" text="{{searchTourValues.searchEightStep}}"
                            class="filter_div" *ngIf="isFilterApplied" floatLabel="always" [ngStyle]="{'width':'130px'}">
                            <input matInput [formControl]="confidentialFilter" [(ngModel)]="searchValue.isConfidential"
                                (keyup)="applyfilter(searchValue)">
                            <button mat-button matSuffix mat-icon-button aria-label="Clear" class="close-icon-bttn"
                                (click)="clearSearchField(displayedColumns[7],searchValue)"
                                *ngIf="searchValue.isConfidential">
                                <mat-icon [ngStyle]="{'font-size':'large', 'cursor':'pointer', 'vertical-align':'initial'}">
                                    close
                                </mat-icon>
                            </button>
                        </mat-form-field>
                    </div>
                </th>
                <td class="removeBorder" mat-cell  *matCellDef="let element"> {{element.isConfidential}} </td>
            </ng-container>

            <tr mat-header-row *matHeaderRowDef="displayedColumns; sticky: true"></tr>
            <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
            <!-- Row shown when there is no matching data. -->
            <tr class="mat-row" *matNoDataRow>
                <td  class="removeBorder" mat-cell colspan="12" *ngIf="this.meetingDataSource.totalCount=== 0">No data matching the
                    filter</td>
            </tr>
        </table>
    </div>
    <div class="table-footer">
        <mat-paginator [pageSizeOptions]="[25,50,75,100]" joyrideStep="searchTenStep"
            text="{{searchTourValues.searchTenStep}}" [pageSize]="25" showFirstLastButtons
            aria-label="Select page of periodic elements" (page)="onPaginateChange($event)">
        </mat-paginator>
    </div>

</div>
